import { queryTypes, useQueryStates } from "next-usequerystate";
import { useMemo } from "react";
import { PAGINATION_DEFAULTS } from "./defaults";
export function usePaginationQuery(useQuery) {
    let config = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
        initialPagination: {
            page: PAGINATION_DEFAULTS.page,
            limit: PAGINATION_DEFAULTS.limit,
            search: null
        }
    };
    const [currentPagination, setCurrentPagination] = useQueryStates({
        page: queryTypes.integer.withDefault(config.initialPagination.page),
        limit: queryTypes.integer.withDefault(config.initialPagination.limit),
        search: queryTypes.string.withDefault(config.initialPagination.search)
    });
    const query = useQuery(currentPagination);
    const { data  } = query;
    const goToNext = data && data.meta.totalPages > currentPagination.page ? ()=>setCurrentPagination((prevState)=>{
            if (prevState.page < (data ? data.meta.totalPages : 0)) prevState.page++;
            return prevState;
        }, {
            shallow: true
        }) : undefined;
    const goToPrevious = currentPagination.page > 1 ? ()=>setCurrentPagination((prevState)=>{
            if (prevState.page > 1) prevState.page--;
            return prevState;
        }, {
            shallow: true
        }) : undefined;
    const goToPage = (page)=>setCurrentPagination({
            page
        }, {
            shallow: true
        });
    const goToFirst = currentPagination.page !== 1 ? ()=>setCurrentPagination({
            page: 1
        }, {
            shallow: true
        }) : undefined;
    const goToLast = data && currentPagination.page < data.meta.totalPages ? ()=>setCurrentPagination(data ? {
            page: data.meta.totalPages
        } : {
            page: 1
        }, {
            shallow: true
        }) : undefined;
    const changeLimit = (limit)=>{
        return setCurrentPagination({
            page: 1,
            limit
        }, {
            shallow: true
        });
    };
    const changeSearch = (search)=>{
        return setCurrentPagination({
            page: 1,
            search
        }, {
            shallow: true
        });
    };
    return useMemo(()=>{
        return {
            ...query,
            pagination: {
                goToFirst,
                goToLast,
                goToNext,
                goToPrevious,
                goToPage,
                currentPage: currentPagination.page,
                currentLimit: currentPagination.limit,
                currentSearch: currentPagination.search,
                changeLimit,
                changeSearch,
                totalPages: (data === null || data === void 0 ? void 0 : data.meta.totalPages) || 0,
                totalItems: (data === null || data === void 0 ? void 0 : data.meta.totalItems) || 0
            }
        };
    }, [
        currentPagination,
        data
    ]);
}
